<div class="mb-3">
  <div class="form-check form-switch ">
    <app-field-title [titleInfo]="detailInfo" [formControlObj]="formControlObj">
      <input type="checkbox" class="form-check-input" [id]="'detail-info-check-' + detailInfo.evideInputContentGuid"
        [formControl]="formControlObj">
    </app-field-title>
  </div>
</div>